<template>
  <div class="flex-center justify-between p-4 md:py-2 bg-white md:border-b">
    <niceone-image :src="$publicPath('/images/cart-buttons/close-cart.svg')" class="hidden cursor-pointer md:block"
                   width="16" @click="closeSideBar"/>
    <div
        class="text-lg text-primary font-niceone-bold flex items-center justify-center flex-row md:flex-col gap-2 md:gap-0 tracking-wider">
      {{ $t('menu.bag') }}
      <div v-if="productsQuantity" class="text-sm mt-0.5 text-[#B0B0B0] font-niceone-normal tracking-wide">{{ productsQuantity }}</div>
    </div>
    <div class="flex-center gap-4">
      <nuxt-link :to="$routerUrl('/favourite')" class="relative flex">
        <van-badge :content="wishlistItemsCount" :max="99" :position="$i18n.locale === 'en' ? 'top-right' : 'top-left'"
                   :show-zero="false" color="black">
          <niceone-image :src="$publicPath('/images/cart-buttons/new-heart-icon.svg')" width="22"/>
        </van-badge>
      </nuxt-link>
      <cart-share/>
    </div>
  </div>
</template>

<script setup>
import {useCartStore} from '@/store/cart'
import CartShare from "@/components/cart/Share"
import {useWishlistStore} from '@/store/wishlist'

const wishlistStore = useWishlistStore()
const {products} = storeToRefs(wishlistStore)
const wishlistItemsCount = computed(() => products.value?.length || 0)

const cartStore = useCartStore()
const {cart,cartProducts, showCart} = storeToRefs(cartStore)
const productsQuantity = computed(() => cart.value?.total_product_count_with_text)

const closeSideBar = () => showCart.value = false
</script>
